import { Link, useParams } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';

import RoleApi from 'api/role';

import SubmitButton from 'components/ui/buttons/SubmitButton';
import withModalView from 'components/ui/withModalView';
import withAuthorizer from 'components/ui/withAuthorizer';
import PermissionList from 'components/roles/PermissionList';

import { Resources } from 'helpers/ResourceHelper';

const FormRolePage = ({ roles = [], back }) => {
  const { t } = useTranslation();

  const { roleId } = useParams();
  const queryClient = useQueryClient();

  const role = roles.find(role => role.id === roleId) || {};

  const mutationParams = {
    onSuccess: () => {
      queryClient.invalidateQueries('roles');
    },
  };

  const createMutation = useMutation(data => RoleApi.create(data), mutationParams);
  const updateMutation = useMutation(data => RoleApi.update(roleId, data), mutationParams);

  const onSubmit = async e => {
    e.preventDefault();

    const permissions = {};
    const form_instance = new FormData(e.target);
    const form_entries = Object.fromEntries(form_instance);
    const permissions_data = Array.from(document.querySelectorAll('input[type="checkbox"]'));

    for (const permission of permissions_data) {
      permissions[permission.id] = permission.checked;
    }

    form_entries.permissions = permissions;

    if (roleId) {
      await updateMutation.mutate(form_entries);
    } else {
      await createMutation.mutate(form_entries);
      back();
    }
  };

  const header_key = roleId ? 'actions.edit' : 'actions.add';
  const disabled = createMutation.isLoading || updateMutation.isLoading;

  return (
    <>
      <div className="container">
        <h1 className="m-0 p-0 fw-lighter">{t(header_key)}</h1>
      </div>

      <div className="container mt-4">
        <form onSubmit={onSubmit}>
          <div className="form-group col-md-4 mb-4">
            <div>{t('admin.roles.form.name_input.label')}</div>
            <input
              type="text"
              disabled={disabled}
              defaultValue={role.name}
              className="form-control"
              name="name"
              autoComplete="off"
              placeholder={t('admin.roles.form.name_input.placeholder')}
              required
            />
          </div>

          <h4>{t('admin.roles.form.sections.permissions.title')}</h4>
          <PermissionList permissions={role.permissions || {}} />

          <div className="d-flex align-items-center mt-5">
            <SubmitButton loading={disabled} className="me-2 btn btn-primary" />

            <Link disabled={disabled} to={`/admin`} className="btn btn-light d-none d-lg-block">
              {t('actions.cancel')}
            </Link>
          </div>
        </form>
      </div>
    </>
  );
};

export default withModalView(withAuthorizer(FormRolePage, [Resources.ROLE_MANAGER]));
